Ext.define('SA.view.AnchoredWindow', {
    alias: 'widget.anchored-window',
    extend: 'SA.view.SimpleContainer',

    moveToAnchor() {
        var anchor = this.anchor,
            anchorType = anchor.anchor || 'cc',
            vertical = anchorType.charAt(0),
            horizontal = anchorType.charAt(1),
            x = Ext.isNumber(anchor.x) ? anchor.x : Ext.dom.Element.getViewportWidth() / 2,
            y = Ext.isNumber(anchor.y) ? anchor.y : Ext.dom.Element.getViewportHeight() / 2,
            winHeight = this.getHeight(),
            winWidth = this.getWidth(),
            parentEl = this.el.parent(),
            parentHeight = parentEl.getHeight(),
            parentWidth = parentEl.getWidth();

        if (vertical === 'c') {
            y -= winHeight / 2;
        }
        else if (vertical === 'b') {
            y -= winHeight;
        }

        if (horizontal === 'c') {
            x -= winWidth / 2;
        }
        else if (horizontal === 'r') {
            x -= winWidth;
        }

        if (x + winWidth > parentWidth) {
            x = parentWidth - winWidth;
        }

        if (x < 0) {
            x = 0;
        }

        if (y + winHeight > parentHeight) {
            y = parentHeight - winHeight;
        }

        if (y < 0) {
            y = 0;
        }

        this.showAt(x, y);
    },

    onHide() {
        this.callParent(arguments);

        this.un('resize', this.moveToAnchor, this);
    },

    setAnchor(anchor) {
        this.anchor = anchor || this.anchor || {};
    },

    showAnchored(anchor) {
        this.setAnchor(anchor);

        this.showAt(-10000, -10000);

        this.moveToAnchor();

        this.un('resize', this.moveToAnchor, this);
        this.on('resize', this.moveToAnchor, this);
    }
});